import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./reducers/userSlice";
export default configureStore({
  reducer: {
    userSlice: userSlice,
  },
});
